// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2e006d4a","498":"405c592b","617":"a878d416","640":"643a9855","828":"6fdb566c"}[chunkId] + ".chunk.js";
};